import { useEffect, useState } from "react";
import { getFundTypeAPI } from "../../../services/employee";

export default function UseTypeOfFund() {
  const [fundType, setFundType] = useState([]);

  useEffect(() => {
    const getFundType = async () => {
      const data = await getFundTypeAPI();
      if (!data && !data.status) return;
      const newData = data.result.map((d, i) => {
       
        return {
          value: d.id,
          label: d.plan_name,
          id: d.id,
          plan_1: d.PVDMFAI,
          plan_2: d.PVDMFEQ,
          plan_3: d.PVDMFIF,
          plan_4: d.PVDMFAI
        };
      });
      setFundType(newData);
    };
    getFundType();
  }, []);
  return fundType;
}
